<form #formEvennement="ngForm">
  <mat-card [ngClass]="getClass()">
    <mat-card-header class="titreFrm">
      <mat-card-title>ÉVÈNEMENT</mat-card-title>
    </mat-card-header>
    <mat-card-content class="border">
      <!------------ bare de chargement ----------------->
      <div *ngIf="exist; else attente"></div>
      <ng-template #attente>
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </ng-template>
      <!------------ bouton ----------------->
      <div class="btn">
        <div class="button-row">
          <button
            [disabled]="!exist"
            (click)="retourListes()"
            mat-raised-button
            class="colorGreen"
          >
            <mat-icon>format_list_bulleted</mat-icon>
            Liste des évènements
          </button>
        </div>
        <div class="button-row">
          <button
            [disabled]="!exist"
            (click)="enregistrerEvenement(formEvennement)"
            mat-raised-button
            class="colorGreen"
          >
            <mat-icon>save</mat-icon>Enregistrer
          </button>
        </div>
        <div class="button-row">
          <button
            [disabled]="!exist"
            *ngIf="
              typeTrs == '2' &&
              evenement.Evenement_Code != '' &&
              evenement.Evenement_Code != null
            "
            (click)="diffuserEvenement()"
            mat-raised-button
            class="colorGreen"
          >
            <mat-icon>share</mat-icon>Diffuser
          </button>
        </div>
      </div>
      <div class="displayFlex">
        <mat-card class="card" style="width: 550px">
          <mat-card-content>
            <div class="display-Flex">
              <div>
                <img
                  (click)="selectImage()"
                  style="max-height: 150px"
                  [src]="avatarSrc"
                />
                <input
                  type="file"
                  style="display: none"
                  id="imageFile"
                  (change)="onChangeImagefile($event)"
                />
              </div>
              <div>
                <mat-form-field
                  appearance="outline"
                  style="width: 130px; margin-right: 20px"
                >
                  <mat-label>Date debut</mat-label>
                  <input
                    [disabled]="disabled"
                    matInput
                    name="Evenement_DateDebut"
                    #Evenement_DateDebut="ngModel"
                    [(ngModel)]="evenement.Evenement_DateDebut"
                    [matDatepicker]="picker1"
                    placeholder="Date debut"
                    required
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="picker1"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #picker1></mat-datepicker>
                </mat-form-field>
                <mat-form-field appearance="outline" style="width: 130px">
                  <mat-label>Date fin</mat-label>
                  <input
                    [disabled]="disabled"
                    matInput
                    name="Evenement_DateFin"
                    #Evenement_DateFin="ngModel"
                    [(ngModel)]="evenement.Evenement_DateFin"
                    [matDatepicker]="picker2"
                    placeholder="Date fin"
                    required
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="picker2"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #picker2></mat-datepicker>
                </mat-form-field>
                <br />
                <mat-form-field
                  appearance="outline"
                  style="width: 80px; margin-right: 20px"
                >
                  <mat-label>H.D&eacute;but</mat-label>
                  <input
                    [disabled]="disabled"
                    matInput
                    name="Evenement_HeureDebut"
                    #Evenement_HeureDebut="ngModel"
                    [matAutocomplete]="auto9"
                    [(ngModel)]="evenement.Evenement_HeureDebut"
                    (blur)="HeureEvenementBlur($event, 'Evenement_HeureDebut')"
                    placeholder="H.D&eacute;but"
                    required
                    (input)="timeChange($event)"
                  />
                  <mat-autocomplete #auto9="matAutocomplete">
                    <mat-option
                      *ngFor="let option of filterdTime"
                      [value]="option"
                    >
                      {{ option }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
                <mat-form-field appearance="outline" style="width: 80px">
                  <mat-label>H.Fin</mat-label>
                  <input
                    [disabled]="disabled"
                    matInput
                    name="Evenement_HeureFin"
                    #Evenement_HeureFin="ngModel"
                    [matAutocomplete]="auto8"
                    [(ngModel)]="evenement.Evenement_HeureFin"
                    (blur)="HeureEvenementBlur($event, 'Evenement_HeureFin')"
                    placeholder="H.Fin"
                    required
                    (input)="timeChange($event)"
                  />
                  <mat-autocomplete #auto8="matAutocomplete">
                    <mat-option
                      *ngFor="let option of filterdTime"
                      [value]="option"
                    >
                      {{ option }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </div>
            </div>

            <mat-form-field appearance="outline" class="heightInput full-width">
              <mat-label>Titre</mat-label>
              <input
                matInput
                [disabled]="disabled"
                name="Evenement_Titre"
                #Evenement_Titre="ngModel"
                [(ngModel)]="evenement.Evenement_Titre"
                placeholder="Titre"
                required
              />
            </mat-form-field>
            <!-- <mat-form-field     appearance="outline"  class="full-width">
                <mat-label>Information</mat-label>
                <textarea matInput [disabled]="disabled" name="Evenement_Information" #Evenement_Information="ngModel"
                  [(ngModel)]="evenement.Evenement_Information" placeholder="Information"></textarea>
              </mat-form-field> -->

            <app-editor
              #editor
              [id]="'editot-text'"
              [config]="{ height: 100 }"
            ></app-editor>
            <!-- <angular-editor  [config]="editorConfig" placeholder=" "  name="ccc" [(ngModel)]="evenement.Evenement_Titre"></angular-editor> -->
          </mat-card-content>
        </mat-card>

        <mat-card class="card">
          <mat-card-content>
            <div class="displayFlex">
              <div style="margin-right: 10px">
                <h4>Type public</h4>
                <button (click)="selectAll()" mat-button>
                  <mat-icon>done_all</mat-icon>&nbsp;Tout sélectionner
                </button>
                <button (click)="deSelectAll()" mat-button>
                  <mat-icon>close</mat-icon>&nbsp;Annuler
                </button>
                <div style="border: 1px solid rgb(226, 224, 230) !important">
                  <mat-selection-list
                    [disabled]="disabled"
                    name="ev_Type_public"
                    #ev_Type_public
                    (selectionChange)="onSelectionTypesPublic()"
                    style="height: 200px; overflow-y: scroll"
                  >
                    <mat-list-option
                      [ngStyle]="{ height: '35px' }"
                      [(ngModel)]="typePublic.Menu_Code"
                      *ngFor="let typePublic of typesPublic"
                    >
                      {{ typePublic.Menu_Code }}
                    </mat-list-option>
                  </mat-selection-list>
                </div>
              </div>
              <div>
                <h4>Type diffusion</h4>
                <button (click)="selectAll2()" mat-button>
                  <mat-icon>done_all</mat-icon>&nbsp;Tout sélectionner
                </button>
                <button (click)="deSelectAll2()" mat-button>
                  <mat-icon>close</mat-icon>&nbsp;Annuler
                </button>
                <div style="border: 1px solid rgb(226, 224, 230) !important">
                  <mat-selection-list
                    [disabled]="disabled"
                    name="ev_Type_diffusion"
                    #ev_Type_diffusion
                    (selectionChange)="onSelectionTypesDiffusion()"
                    style="height: 150px; overflow-y: scroll"
                  >
                    <mat-list-option
                      [ngStyle]="{ height: '35px' }"
                      [(ngModel)]="typePublic.value"
                      *ngFor="let typePublic of diffusions"
                    >
                      {{ typePublic.text }}
                    </mat-list-option>
                  </mat-selection-list>
                </div>

                <!--<br> <mat-radio-group *ngIf="showPositionEvennement" name="XXX" [(ngModel)]="positionEvennement" required="showPositionEvennement">
                    <mat-radio-button [value]="option.value.toString()" *ngFor="let option of listePositionEvennement" >{{option.text}}&nbsp;</mat-radio-button>
                  </mat-radio-group> -->
              </div>
            </div>
          </mat-card-content>
        </mat-card>
        <mat-card
          *ngIf="
            typeTrs != '1' &&
            evenement.Evenement_Code != '' &&
            evenement.Evenement_Code != null
          "
          class="card"
        >
          <mat-card-content>
            <app-show-tree-doc
              [param_code]="evenement.Evenement_Code"
              [File_Type]="'evenementDocument'"
              [typeTrs]="typeTrs"
            ></app-show-tree-doc>
          </mat-card-content>
        </mat-card>
      </div>
    </mat-card-content>
  </mat-card>
</form>
